import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import ProfileFieldGrid from './ProfileFieldGrid'

const Health = props => {
  const { authenticationStore } = props
  const { currentUser } = authenticationStore
  const fields = [
    {
      title: 'Tình trạng sức khỏe',
      value: currentUser?.other?.health_status,
    },
    { title: 'Chiều cao', value: currentUser?.other?.height },
    { title: 'Cân nặng', value: currentUser?.other?.weight },
    { title: 'Nhóm máu', value: currentUser?.other?.blood_types },
    {
      title: 'Là thương binh hạng',
      value: currentUser?.other?.wounded_soldier_class,
    },
    {
      title: 'Là con gia đình chính sách',
      value: currentUser?.other?.child_policy_family,
    },
  ]

  return <ProfileFieldGrid fields={fields} />
}

Health.propTypes = {
  authenticationStore: PropTypes.shape({
    currentUser: PropTypes.shape({
      other: PropTypes.shape({
        health_status: PropTypes.string,
        height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        weight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        blood_types: PropTypes.string,
        wounded_soldier_class: PropTypes.string,
        child_policy_family: PropTypes.string,
      }),
    }),
  }),
}

export default inject('authenticationStore')(observer(Health))
